

class MessageEvent extends Event {
	constructor(message) {
		super("message")
		this.data = message;
	}
}

const getLinesOfCell = (count, lines, x, y) => {
	const al = [];
	for(let l of lines) {
		if((l.x===x || l.x===x+1) && l.y===y && l.isH || l.x===x && (l.y===y || l.y===y+1) && !l.isH) {
			al.push(l);
		}
	}
	return al;
}

const getCells = (count, lines, existingCells) => {
	const cells = [];
	for(let i=0; i<count; i++) {
		for(let j=0; j<count; j++) {
			const ls = getLinesOfCell(count, lines, i, j);
			if(ls.length===4) {
				let latestLine = null;
				for(const line of ls) {
					if(!latestLine || line.time > latestLine.time)
						latestLine = line;
				}
				cells.push({x: i, y: j, pid: latestLine.pid});
			}
		}
	}
	if(existingCells) {
		const newCells = [];
		for(let i of cells) {
			if(!existingCells.find(j => j.x===i.x && j.y===i.y))
				newCells.push(i);
		}
		return newCells;
	}
	return cells;
}

const nextTurn = (lines, count, people, turn, hasCells) => {
	if(lines.length===2*count*(count+1))
		return null;
	if(hasCells)
		return turn;
	const turnIndex = turn!==null?people.findIndex(p => p.pid===turn):people.length-1;
	let nextTurnIndex;
	for(let i=1; i<=people.length; i++) {
		nextTurnIndex = (turnIndex+i)%people.length;
		if(!people[nextTurnIndex].dead) return people[nextTurnIndex].pid;
	}
	return people[nextTurnIndex].pid;
}


export default class LocalController extends EventTarget {
	constructor({name, othername, count}) {
		super();
		this.initData = {name, othername, count};
		this.lines = [];
		this.cells = [];
		this.people = [];
		this.count = count;
		setTimeout(() => {
			const event = new Event('open');
			this.dispatchEvent(event);
		}, 200);
	}
	init() {
		this.people.push({pid: 0, name: this.initData.name, color: '#7bf'})
		this.respond({type: 'accepted', person: {pid: 0, color: '#7bf', name: this.initData.name}, game: {count: this.initData.count, gameid: 1}})
		this.respond({type: 'turn', pid: 0, sensors: true})
		const otherPerson = {pid: 1, color: '#ea4', name: this.initData.othername}
		this.respond({type: 'person', person: otherPerson})
		this.people.push(otherPerson);
		this.initData = null;
	}
	send(data) {
		if(data.type === "line") {
			this.lines.push({...data.line, time: Date.now()});
			const newCells = getCells(this.count, this.lines, this.cells);
			const turn = nextTurn(this.lines, this.count, this.people, this.turn, newCells.length?true:false)
			if(newCells.length)
				this.cells = [...this.cells, ...newCells];
			this.respond({type: 'turn', pid: turn, sensors: true});
		}
	}
	respond(msg) {
		if(msg.type==="turn") this.turn = msg.pid;
		const e = new MessageEvent(msg);
		setTimeout(() => {
			this.dispatchEvent(e)
		}, 200);
	}
}
